import styled from 'styled-components'

export const TabWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 36px;
  margin-top: -3rem;
`

export const DatasetTab = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-bottom: ${({ selected }) => (selected ? '2px solid #2563eb' : '2px solid transparent')};
  cursor: pointer;
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  color: ${({ selected }) => (selected ? '#2563eb' : '#444')};
  position: relative;
  background-color: transparent;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
  border-radius: 6px;

  &:hover {
    background-color: #f9f9f9;
  }
`

export const TabContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  gap: 5px;
  min-width: 60px;
`

export const ActivityDot = styled.span<{ active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${({ active }) => (active ? '#5CE65C' : 'gray')};
`

export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 10;
  margin-top: 4px;
  min-width: 200px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`

export const DropdownItem = styled.div<{ selected: boolean }>`
  padding: 8px;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? '#f0f0f0' : 'transparent')};
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ selected }) => (selected ? '#f0f0f0' : 'var(--color-button-secondary)' || '#f5f5f5')};
  }
`

export const DatasetName = styled.span`
  flex-grow: 1;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
`

export const DropdownIcon = styled.div<{ isOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
    color: var(--color-spun-pearl-grey);
    transition: transform 0.2s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg) translateY(1px)' : 'rotate(0deg) translateY(1px)')};
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);

    svg {
      color: #2563eb;
    }
  }
`
